import React from 'react';

import { usePlanStateField } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/PlanState';

import { HighLightTextField } from './components';

export const Metric = ({ name, typeField, ...props }) => {
  const { value, onChange, resolvedName } = usePlanStateField(name);

  return (
    <HighLightTextField
      value={value}
      onChange={onChange}
      path={resolvedName}
      type={typeField}
      placeholder={'0'}
      width={'58px'}
      {...props}
    />
  );
};
